import axios from 'axios'


const axiosApi = axios.create({
    // baseURL: 'http://localhost:8080' ,
    // baseURL: 'http://3.7.148.233:8000' ,
    // baseURL: 'http://65.1.44.151' ,
    // baseURL: 'http://13.233.223.25',
    baseURL: 'https://maruti.realbooks.in',
    // baseURL: 'http://15.206.74.109:8181',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('user')}`, 'X-RLB-DMS-ACC': localStorage.getItem('acc') }//here we add header to each request
    // headers: { 'x-access-token': localStorage.getItem('user')}//here we add header to each request
    })

export default axiosApi;

export const getHeaderJWT = () => { 
    return{ 
        headers : {'Authorization': `Bearer ${localStorage.getItem('user')}`, 
                    'Content-Type' : 'application/json',
                    'X-RLB-DMS-ACC': localStorage.getItem('acc')
                }
    }
}

// export const URL = 'http://localhost:8080'
// export const URL = 'http://3.7.148.233:8000'
// export const URL = 'http://65.1.44.151'
// export const URL = 'http://13.126.65.85'
export const URL = 'https://maruti.realbooks.in'
// export const URL = 'http://15.206.74.109:8181'
// Maruti local
// ip 192.168.40.101
// export const URL = 'http://192.168.40.101:8181'